module.exports = __webpack_public_path__ + "static/media/pic-instruction.20f0876b.png";